// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  border: 0;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --hue: 223;
  --bg: hsl(var(--hue),90%,25%);
  --fg: hsl(var(--hue),10%,90%);
  --trans-dur: 0.3s;
}

.pbiLoaderWrapper {
  background: var(--bg);
  color: var(--fg);
  font: 1em/1.5 sans-serif;
  display: grid;
  place-items: center;
}

.pl {
  display: block;
  width: 200px;
  height: 200px;
  margin-top: -180px;
}

.pbiLoaderImagewrapper {
  margin-top: 120px;
  width: 150px;
  height: 150px;
}

.pbiLoaderImage {
  max-width: 125px;
  max-height: 125px;
}

#wrapper td {
  vertical-align: middle;
  text-align: center;
}

.pl__ring-rotate,
.pl__ring-stroke {
  animation-duration: 3.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.pl__ring-rotate,
.pl__ring-stroke {
  transform-origin: 80px 80px;
}

.pl__ring-rotate {
  animation-name: ringRotate;
}

.pl__ring-stroke {
  animation-name: ringStroke;
  transform: rotate(-45deg);
}

/* Animations */
@keyframes ringRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(720deg);
  }
}
@keyframes ringStroke {
  from, to {
    stroke-dashoffset: 452;
    transform: rotate(-45deg);
  }
  50% {
    stroke-dashoffset: 169.5;
    transform: rotate(-180deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/pbi-loader/pbi-loader.component.scss"],"names":[],"mappings":"AA0CA;EACC,SAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAzCD;;AA2CA;EACC,UAAA;EACA,6BAAA;EACA,6BAAA;EACA,iBAAA;AAxCD;;AA2CA;EACC,qBAAA;EACA,gBAAA;EACA,wBAAA;EAEA,aAAA;EACA,mBAAA;AAzCD;;AA4CA;EACC,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAzCD;;AA2CA;EACI,iBAAA;EACA,YAAA;EACA,aAAA;AAxCJ;;AA2CA;EACI,gBAAA;EACA,iBAAA;AAxCJ;;AA0CA;EACG,sBAAA;EACA,kBAAA;AAvCH;;AA0CA;;EAEC,wBAAA;EACA,iCAAA;EACA,mCAAA;AAvCD;;AAyCA;;EAEC,2BAAA;AAtCD;;AAwCA;EACC,0BAAA;AArCD;;AAuCA;EACC,0BAAA;EACA,yBAAA;AApCD;;AAuCA,eAAA;AAEA;EACC;IACC,oBAAA;EArCA;EAuCD;IACC,yBAAA;EArCA;AACF;AAuCA;EACC;IAEC,sBAAA;IACA,yBAAA;EAtCA;EAwCD;IACC,wBAAA;IACA,0BAAA;EAtCA;AACF","sourcesContent":["// .pbiLoaderWrapper{\n// \tmax-height: 200px;\n//     max-width: 300px;\n// \t// width: 12rem;\n// \tborder-radius: 6px;\n// \t// position: absolute;\n//     margin-left: calc(50% - 125px);\n// }\n\n// .shineEffect \n// { \n// \tposition: relative;\n// \toverflow: hidden;\n\n// \t&::before {\n// \t\tbackground: linear-gradient(\n// \t\t\tto right,\n// \t\t\tfade_out(#fff, 1) 0%,\n// \t\t\tfade_out(#fff, 0.7) 100%\n// \t\t);\n// \t\tcontent: \"\";\n// \t\tdisplay: block;\n// \t\theight: 100%;\n// \t\tleft: -75%;\n// \t\tposition: absolute;\n// \t\ttop: 0;\n// \t\ttransform: skewX(-35deg);\n// \t\twidth: 50%;\n// \t\tz-index: 2;\n// \t}\n\n//     &::before {\n//         animation: shine 1.5s linear infinite;\n//     }\n\n// \t@keyframes shine {\n// \t\t100% {\n// \t\t\tleft: 125%;\n// \t\t}\n// \t}\n// }\n\n* {\n\tborder: 0;\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\n}\n:root {\n\t--hue: 223;\n\t--bg: hsl(var(--hue),90%,25%);\n\t--fg: hsl(var(--hue),10%,90%);\n\t--trans-dur: 0.3s;\n\t// font-size: calc(16px + (24 - 16) * (100vw - 320px) / (1280 - 320));\n}\n.pbiLoaderWrapper {\n\tbackground: var(--bg);\n\tcolor: var(--fg);\n\tfont: 1em/1.5 sans-serif;\n\t// height: 100vh;\n\tdisplay: grid;\n\tplace-items: center;\n}\n\n.pl {\n\tdisplay: block;\n\twidth: 200px;\n\theight: 200px;\n\tmargin-top: -180px;\n}\n.pbiLoaderImagewrapper{\n    margin-top:120px;\n    width:150px; \n    height:150px;\n}\n\n.pbiLoaderImage{\n    max-width:125px; \n    max-height:125px;\n}\n#wrapper td {\n   vertical-align: middle;\n   text-align: center;\n}\n\n.pl__ring-rotate,\n.pl__ring-stroke{\n\tanimation-duration: 3.5s;\n\tanimation-timing-function: linear;\n\tanimation-iteration-count: infinite;\n}\n.pl__ring-rotate,\n.pl__ring-stroke {\n\ttransform-origin: 80px 80px;\n}\n.pl__ring-rotate {\n\tanimation-name: ringRotate;\n}\n.pl__ring-stroke {\n\tanimation-name: ringStroke;\n\ttransform: rotate(-45deg);\n}\n\n/* Animations */\n\n@keyframes ringRotate {\n\tfrom {\n\t\ttransform: rotate(0);\n\t}\n\tto {\n\t\ttransform: rotate(720deg);\n\t}\n}\n@keyframes ringStroke {\n\tfrom,\n\tto {\n\t\tstroke-dashoffset: 452;\n\t\ttransform: rotate(-45deg);\n\t}\n\t50% {\n\t\tstroke-dashoffset: 169.5;\n\t\ttransform: rotate(-180deg);\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
